import type { CampaignTaskKind } from "../types";
import { CAMPAIGN_TASK_TYPES } from "./campaignTaskTypes";

type TranslateFn = (key: string, options?: { [key: string]: any }) => string;

export const getTranslatedCampaignTaskLabel = (
  kind: CampaignTaskKind,
  translate: TranslateFn,
) => {
  const config = CAMPAIGN_TASK_TYPES.find((t) => t.kind === kind);
  const fallback = config?.label ?? kind;
  return translate(`resources.campaigns.kinds.${kind}`, { _: fallback });
};

export const getTranslatedCampaignMetadataLabel = (
  source: string,
  fallback: string,
  translate: TranslateFn,
) =>
  translate(`resources.campaigns.metadata.${source}`, {
    _: fallback,
  });

export const useCampaignTaskTypeChoices = (translate: TranslateFn) =>
  CAMPAIGN_TASK_TYPES.map((t) => ({
    id: t.kind,
    name: getTranslatedCampaignTaskLabel(t.kind, translate),
  }));
